import TextAreaPrimitive from './TextAreaPrimitive';
import { PrimitiveTextAreaProps } from './TextAreaPrimitive.interfaces';

export default TextAreaPrimitive;
export { TextAreaPrimitive, PrimitiveTextAreaProps };
